import React from "react";
import * as hrmsService from "../../../services/hrmsService";
import { EmptyState, LoadState } from "../hrComponents";
import { badgeStyle, cardStyle, formatDate, formatMinutes, localTime, tdStyle, thStyle, useLoad } from "../hrUi";

// ATT-07: who is in, late, not in yet, or away right now, for the people the caller may see.
export const LIVE_STATES = {
  IN: { label: "In", bg: "#D1FAE5", color: "#065F46" },
  OUT: { label: "Left", bg: "#F3F4F6", color: "#4B5563" },
  NOT_IN: { label: "Not in", bg: "#FEE2E2", color: "#991B1B" },
  EXPECTED: { label: "Expected", bg: "#FEF3C7", color: "#92400E" },
  ON_LEAVE: { label: "On leave", bg: "#DBEAFE", color: "#1E40AF" },
  OFF: { label: "Day off", bg: "#F3F4F6", color: "#4B5563" },
  HOLIDAY: { label: "Holiday", bg: "#EDE9FE", color: "#5B21B6" },
  NONE: { label: "Nothing planned", bg: "#F9FAFB", color: "#6B7280" },
};
const ORDER = ["NOT_IN", "EXPECTED", "IN", "OUT", "ON_LEAVE", "OFF", "HOLIDAY", "NONE"];

export default function TeamToday() {
  const { data, loading, error, reload } = useLoad(() => hrmsService.getTeamToday(), []);
  const people = [...(data?.people || [])].sort((a, b) => ORDER.indexOf(a.state) - ORDER.indexOf(b.state) || String(a.full_name).localeCompare(b.full_name));
  return (
    <LoadState loading={loading} error={error} onRetry={reload}>
      {data ? (
        <>
          <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
            <strong>{formatDate(data.date)}</strong>
            {ORDER.filter((s) => data.counts[s]).map((s) => (
              <span key={s} style={badgeStyle(LIVE_STATES[s].bg, LIVE_STATES[s].color)}>
                {LIVE_STATES[s].label} {data.counts[s]}
              </span>
            ))}
            <button type="button" className="btn btn-outline-secondary btn-sm ms-auto" onClick={reload}>
              Refresh
            </button>
          </div>
          {people.length === 0 ? (
            <EmptyState title="Nobody to show" />
          ) : (
            <div style={{ ...cardStyle, overflowX: "auto" }}>
              <table className="table mb-0" style={{ minWidth: 520 }}>
                <thead>
                  <tr>
                    {["Employee", "Shift", "State", "First in", "Late"].map((h) => (
                      <th key={h} style={thStyle}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {people.map((p) => (
                    <tr key={p.employee_id}>
                      <td style={tdStyle}>
                        <div style={{ fontWeight: 600 }}>{p.full_name}</div>
                        <div style={{ fontSize: 12, color: "#6B7280" }}>{p.employee_code}</div>
                      </td>
                      <td style={tdStyle}>{p.shift_code || "—"}</td>
                      <td style={tdStyle}>
                        <span style={badgeStyle(LIVE_STATES[p.state].bg, LIVE_STATES[p.state].color)}>{LIVE_STATES[p.state].label}</span>
                      </td>
                      <td style={tdStyle}>{localTime(p.first_in_local)}</td>
                      <td style={{ ...tdStyle, color: p.late_minutes ? "#B45309" : undefined }}>{p.late_minutes ? formatMinutes(p.late_minutes) : "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      ) : null}
    </LoadState>
  );
}
